import * as constAction from 'root/actionConstants';

/**
 * Setea un campo o el reducer completo del componente con el default.
 * @param {string} value Nombre del campo a limpiar ("all" para todo el reducer).
 * @returns {Object}
 */
export const clear = value => ({
  type: constAction.MENSAJES_CLEAR,
  payload: value,
});

/**
 * Setea un campo en el reducer .
 * @param {Object} values - Campos a setear.
 * @param {string} values.* - Nombre y valor del campo a setear.
 * @returns {Object}
 */
export const setState = values => ({
  type: constAction.MENSAJES_SET_STATE,
  payload: values,
});

/**
 * Trae la lista de mensajes .
 * @returns {Object}
 */
export const get = (fecha, all) => ({
  type: constAction.MENSAJES_GET,
  payload: { fecha, all },
  epic: {
    url: 'mensajes/getAll',
    method: 'POST',
  },
});

/**
 * Guarda un mensaje
 * @param {[object]} data Datos del mensaje
 */
export const set = data => ({
  type: constAction.MENSAJES_SET,
  payload: {
    ...data,
  },
  epic: {
    url: 'mensajes/add',
    method: 'POST',
  },
});

/**
 * Guarda un mensaje
 * @param {[object]} data Datos del mensaje
 */
export const setUsuario = (mensaje, usuarioId, fechaCaducidad) => ({
  type: constAction.MENSAJES_USUARIO_SET,
  payload: { mensaje, usuarioId, fechaCaducidad },
  epic: {
    url: 'mensajes/toUser',
    method: 'POST',
  },
});

/**
 * Trae la lista de mensajes de un usuario.
 * @returns {Object}
 */
export const getUsuario = (usuarioId, fecha) => ({
  type: constAction.MENSAJES_USUARIO_GET,
  payload: { usuarioId, fecha },
  epic: {
    url: 'mensajes/getFromUser',
    method: 'GET',
  },
});

export const deleteMsg = mensajeId => ({
  type: constAction.MENSAJES_DELETE,
  payload: {
    mensajeId,
  },
  epic: {
    url: 'mensajes/delete',
    method: 'POST',
  },
});



// WEBPACK FOOTER //
// src/modules/mensajes/action.js